module.exports = __webpack_public_path__ + "static/media/number-5-normal.ad9c7290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/numbers/number-5-normal.svg
// module id = 276
// module chunks = 0